import { defineComponent, computed } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { useI18n } from 'vue-i18n';
import Image from '@hems/component/src/image/Image.vue';
import { INFO_NOTIFICATION_MODAL_TYPE } from '@hems/util/src/constant/modal';
export default defineComponent({
    name: 'InfoNotificationModal',
    components: { VueFinalModal, Image },
    props: {
        type: {
            type: String,
            default: INFO_NOTIFICATION_MODAL_TYPE.INFO,
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },
    emits: ['confirm', 'close'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const isIcon = computed(() => props.type !== INFO_NOTIFICATION_MODAL_TYPE.INFO);
        const isInfoModal = computed(() => props.type === INFO_NOTIFICATION_MODAL_TYPE.INFO);
        const isConfirmModal = computed(() => props.type === INFO_NOTIFICATION_MODAL_TYPE.CONFIRM);
        const cancelButtonText = computed(() => ({
            [INFO_NOTIFICATION_MODAL_TYPE.INFO]: t('common.cancel'),
            [INFO_NOTIFICATION_MODAL_TYPE.ERROR]: t('common.close'),
            [INFO_NOTIFICATION_MODAL_TYPE.SUCCESS]: t('common.close'),
            [INFO_NOTIFICATION_MODAL_TYPE.CONFIRM]: t('common.cancel'),
        }));
        const iconName = {
            [INFO_NOTIFICATION_MODAL_TYPE.INFO]: '',
            [INFO_NOTIFICATION_MODAL_TYPE.ERROR]: 'ic_re_error_glass_img',
            [INFO_NOTIFICATION_MODAL_TYPE.SUCCESS]: 'ic_re_check_glass_img',
            [INFO_NOTIFICATION_MODAL_TYPE.CONFIRM]: 'ic_re_error_glass_img',
        };
        const onClose = (close) => {
            emit('close');
            close();
        };
        const onConfirm = (close) => {
            emit('confirm');
            close();
        };
        return {
            isIcon,
            iconName,
            isInfoModal,
            isConfirmModal,
            cancelButtonText,
            onClose,
            onConfirm,
        };
    },
});
